<template>
    <b-card>
      <b-row>
        <b-col sm="6" lg="3"  v-for="nextItem in items" v-bind:key="nextItem.id">
          <lock-card :nextItem=nextItem :locationId=locationId :lockGroupId=lockGroupId></lock-card>
        </b-col>
      </b-row>
      <div v-if="items.length == 0">
        <div class="alert alert-danger">
          <ul class="fa-ul" style="margin-bottom: 0px;">
            <li>
              <i class="fa fa-info-circle fa-li"></i>
              Please assign lock to lock group<br/>
              Click "Lock List" from left menu > Click "Menu" from selected Lock > Select "Add Lockgroup"
            </li>
          </ul>
        </div>
      </div>
    </b-card>
</template>

<script>
import LockCard from '@/views/base/haus/LockCard'
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
//const API = BASE + '/api/locks/listForLockgroup'
const API_ASSIGN_LOCK_TO_LOCATION = BASE + '/api/locks/assignLocation'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken,
      'authorization': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

// async function getData (lockGroupId) {
//   //alert(lockGroupId)
//   let param = {
//     client_id: constants.NEWPORT_CONST.CLIENT_ID,
//     client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
//     accessToken: localStorage.getItem('token'),
//     lockGroupId: lockGroupId
    
//   }
//   let res = await postdata(API, param)
//   return res.locks
// }

export default {
  name: 'locks-lockgroup',
  props: ['lockGroupId', 'lockGroupName', 'locationId'],
  components: {
    LockCard
  },
  data: () => {
    return {
      items: [],
      currentPage: 1,
      perPage: 25,
      totalRows: 0,
      filter: null,
      selected: [],
      selectAll: false
    }
  },
  mounted () {

    let lockGroupId = this.lockGroupId
    // getData(lockGroupId).then(response => {
      
    //   alert(JSON.stringify(response))
    //   this.$data.items = response
    // })

    // let localLocksList = localStorage.getItem('locksForLocation')
    // if(localLocksList) {
    //   localLocksList = JSON.parse(localLocksList)
    //   this.$data.items = localLocksList.filter(lock => lock.lockGroups.some(lockGroup => lockGroup.lockGroupId===lockGroupId))
  
    // }

    let localLocksList = localStorage.getItem('localLocksList')
    if(localLocksList) {
      localLocksList = JSON.parse(localLocksList)
      this.$data.items = localLocksList.filter(lock => lock.lockGroups.some(lockGroup => lockGroup.lockGroupId===lockGroupId))

    }

    

    // let localLockGroupId = localStorage.getItem('localLockGroupId')

    // if(localLockGroupId) {
    //   this.$data.items = JSON.parse('localLockGroupId')
    // }
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    openlink (link) {
      location.href = link
    },
    assignToLocation (lockId, idx) {
      let parameters = {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        lockId: lockId,
        locationId: localStorage.getItem('locationId')
      }
      postdata(API_ASSIGN_LOCK_TO_LOCATION, parameters)
        .then(data => {
          console.log(data)
        })
        .catch(error => {
          console.error(error)
        })
      this.$data.items.splice(idx, 1)
    },
    lockDevice (idx) {
    },
    unlockDevice (idx) {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/LocksLockgroup.vue